import React from 'react';

export default class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if(!this.props.content) {
            return null;
        }
        
        return (
        <div className="footer">
            <div className="container">
                <p dangerouslySetInnerHTML={{__html: this.props.content}} />
            </div>
        </div>);
    }
}

Footer.propTypes = {
    content: React.PropTypes.string
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Footer.jsx